var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-fluid",attrs:{"id":"admin-template"}},[_c('div',{staticClass:"span9"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('div',{staticClass:"span3"},[_c('router-view',{attrs:{"name":"sidebar"}})],1),_c('FlashMessage',{attrs:{"position":'right bottom'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }